module.exports = __webpack_public_path__ + "img/daci_snap.d6b5bdfb.png";